<script lang="ts">
    import { KEY_ESC } from "@/constants";
    import { portal } from "@ui-utils/actions/portal";
    import CN from "classnames";
    import { createEventDispatcher, tick } from "svelte";

    import { MODAL_CLOSE_EVENT } from "./constants";
    import ModalBackdrop from "./ModalBackdrop.svelte";

    let className: string | undefined = undefined;
    export let style: string | undefined = undefined;
    export let open = false;
    export let openedModalOrder = 0;
    export let openedModalsCount = 0;
    export let disablePortal = false;
    export { className as class };
    let modalElement: null | HTMLDivElement = null;
    const dispatch = createEventDispatcher();

    const handleBackdropClick = () => {
        dispatch(MODAL_CLOSE_EVENT);
    };

    const handleEsc = (e: KeyboardEvent) => {
        if (e.code === KEY_ESC) {
            dispatch(MODAL_CLOSE_EVENT);
        }
        dispatch("keydown", e);
    };

    const setFocus = async () => {
        await tick();
        modalElement?.focus();
    };

    $: {
        if (openedModalsCount > 0) {
            window.document.documentElement.classList.add("no-scroll");
        } else {
            window.document.documentElement.classList.remove("no-scroll");
        }
    }

    $: {
        if (open) setFocus();
    }
</script>

{#if open}
    <div
        bind:this={modalElement}
        on:keydown={handleEsc}
        use:portal={{
            disablePortal,
        }}
        tabindex="-1"
        class={CN("gw-modal", className, {
            "gw-modal--open": open,
        })}
        style={`--gw-modal-order: ${openedModalOrder}; ${style || ""}`}
    >
        <ModalBackdrop on:click={handleBackdropClick} />
        <div class="gw-modal__content">
            <slot />
        </div>
    </div>
{/if}

<style lang="postcss">
    .gw-modal {
        display: none;
        position: fixed;
        z-index: calc(var(--gw-z-index-modal) + var(--gw-modal-order));
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        outline: 0;

        &--open {
            display: block;
        }

        &__content {
            display: flex;
            justify-content: center;
            align-items: center;
            height: auto;
            min-height: 100%;

            @media all and (max-width: 900px) {
                align-items: flex-end;
            }
        }
    }
</style>
